/* eslint-disable */
import SmoothScroll from 'smooth-scroll'
import { productsWrapper } from '../wrapper/ProductsWrapper'
import { navWrapper } from '../wrapper/NavWrapper'


class ScrollService {
    inprogress = false
	scroll = new SmoothScroll()
    addToScroll = 30
    speed = 100

    get fixedMenuHeight () {
        let horizontal = document.querySelector('.category-lists__horizontal')
        if(horizontal) return document.querySelector('nav').getBoundingClientRect().height + 80
        return document.querySelector('nav').getBoundingClientRect().height
    }

    scrollTo(product){
        
        this.scroll.animateScroll(product.element, null, {
            offset: this.fixedMenuHeight,
            speed: this.speed,
            updateURL: false
        })
    }

    _listenToScroll(){
        productsWrapper.products.forEach(product => {this.isDisplayed(product)})
    }

    isDisplayed(product){
        const current = window.scrollY - document.getElementById('category-products').offsetTop + 158
        if(product.min <= current  && product.max >= current) {
            product.nav.classList.add("active");
            if(!productsWrapper.isOpen(product.accordion)) {
                productsWrapper.closeAll();
                productsWrapper.open(product.accordion);
            }
        }
        else 
        {
            product.nav.classList.remove("active");
        }

        let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));
        if(isSafari)
        navWrapper.container.classList.add('safari-fixed-nav')

        if(productsWrapper.products.at(-1).max < window.scrollY + window.innerHeight - this.addToScroll ) 
        navWrapper.container.classList.add('hide-nav')
        else navWrapper.container.classList.remove('hide-nav')
        
    }

    addListener () {
		this._listener = this._listenToScroll.bind(this)
		window.addEventListener('scroll', this._listener)
	}

}

const scrollService = new ScrollService()
export { ScrollService, scrollService }
